import PageContainer from '@/common/components/PageContainer'
import useQueryGetProfilePageBanners from '@/modules/client-setting/api/hooks/useQueryGetProfilePageBanners'
import ProfilePageBannerListing from '@/modules/client-setting/components/ProfilePageBanner/components/ProfilePageBannerListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function ProfilePageBannerPage() {
	const { data, isLoading } = useQueryGetProfilePageBanners()

	return (
		<PageContainer>
			<ProfilePageBannerListing data={data || []} isLoading={isLoading} />
		</PageContainer>
	)
}

const GuardedProfilePageBannerPage = withUserPermission(ProfilePageBannerPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedProfilePageBannerPage
